import "./App.css";
import { getNewsList, category } from "./api";
import { useEffect, useState } from "react";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import Toggle from "./components/Toggle";

function App() {
  const [listNews, setNews] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isCategory, setIscategory] = useState("Silahkan Pilih Kategori");
  useEffect(() => {
    setIsLoading(true);
    getNewsList().then((result) => {
      try {
        setNews(result);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    });
  }, []);

  const CategoryHandle = async (c) => {
    setIsLoading(true);
    const query = await category(c);

    var title = query.data.title;
    var newString = title.replace(/CNN Indonesia - | - CNN Indonesia/, "");
    // console.log(newString);
    // console.log(query.data.title)
    setIscategory(newString);
    setNews(query.data.posts);
    setIsLoading(false);
  };

  const PopularNewsList = () => {
    return listNews.map((news, i) => {
      return (
        <div className="col-span-12 md:col-span-6 lg:col-span-3 pt-2" key={i}>
          <div className="card bg-base-100 shadow-md shadow-orange-100">
            <figure>
              <img
                className="max-w-xs transition duration-500 ease-in-out hover:scale-110"
                src={news.thumbnail}
                alt="News"
              />
            </figure>
            <div className="card-body">
                <a
                  href={news.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="card-title text-base hover:text-sky-600"
                >
                  { news.title }
                </a>
              <hr />
              {/* <p className="text-base">{news.description}</p> */}
              <div className="card-actions justify-end pt-3">
                <a
                  href={news.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm  btn-secondary"
                >
                  Baca selengkapnya
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  // console.log({fronttest: listNews})
  // console.log({fronttest: listNews.data.description})
  return (
    <div className="App">
      <header className="App-header container-fluid pt-5">
        <h1 className="text-5xl font-extralight shadow-sm hover:text-sky-400 duration-300 ">
          Reztech News
        </h1>
        <Toggle />
        
        <small className="text-base">{isCategory && isCategory}</small>
        {/* {<Loader />} */}
          {isLoading && <Loader />}
        <div className="pt-3">
          <div className="grid gap-4 grid-cols-2">
            <div
              className="btn btn-sm btn-secondary rounded-full"
              onClick={() => CategoryHandle("terbaru")}
            >
              Umum - Terbaru
            </div>
            <div
              className="btn btn-sm btn-primary rounded-full text-white"
              onClick={() => CategoryHandle("teknologi")}
            >
              Tehcnology
            </div>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-4 pt-6 p-8 pb-10">
          <PopularNewsList />
        </div>
      </header>
      {!isLoading && <Footer />}
    </div>
  );
}

export default App;
